import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import Link from '@common/Link';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import * as styles from './links-features.module.scss';

const LinksFeatures = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data; 
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        <Row className='row-cols-md-3 g-3 justify-content-center'>
          {list && list.map((item, index) => (
            <div key={index} className='d-flex'>
              <Link to={item.link} className={clsx(styles.card, {[`d-flex flex-column justify-content-between border border-3 border-${item.bgColour} rounded p-3 no-hover`]:item.bgColour})}>
                <div>
                  {item.title && <p className='fs-24 fw-medium text-black'>{item.title}</p>}
                  {item.subtitle && <p className='fs-16 fw-normal text-black mb-lg-8'>{item.subtitle}</p>}
                </div>
                {item.linkCopy &&
                  <div className='d-flex align-items-center'>
                    <p className='mb-0 show-hover'>{item.linkCopy}</p> <FontAwesomeIcon icon={faChevronRight} size='sm' className='ms-1'/>
                  </div>
                }
              </Link>
            </div>
          ))}
        </Row>
      </Container>
    </Section>
  )
}

export default LinksFeatures
